/**
 * Gets max possible value from data points collection
 *
 * @param data - Plot's data
 * @returns max value
 */
export const getMaxDataPointValues = (data) => (data.reduce((acc, { expectedPValueLog, observedPValueLog }) => (Object.assign(Object.assign({}, acc), { x: expectedPValueLog > acc.x ? expectedPValueLog : acc.x, y: observedPValueLog > acc.y ? observedPValueLog : acc.y })), { x: 0, y: 0 }));
